module.exports = __webpack_public_path__ + "media/shinei1.829ee1bf.mp3";